import React from 'react';

import Text from '../../../components/Text';
import Icon from '../../../components/Icon';
import Sidebar from '../components/Sidebar';
import SidebarSection from '../components/Sidebar/SidebarSection';
import CreateTicket from '../components/Sidebar/CreateTicket';
import Separator from '../components/Separator';
import { $l } from '../../../locales';
import ChatButton from '../components/Sidebar/ChatButton';
import { makeQAAttributes } from '../../../utils/qaAttributes';
import { QA_RIGHT_SIDEBAR } from '../../../constants/qaAttributes';

const SidebarRight = () => (
  <Sidebar position="right" className="sp-block--hide-900">
    <div className="sp-sidebar__inner">
      <ChatButton />
      <SidebarSection>
        <Text element="h3">{$l('CONTACT_US')}</Text>
      </SidebarSection>
      <SidebarSection className="sp-sidebar__section--offset--b-null">
        <a
          {...makeQAAttributes(QA_RIGHT_SIDEBAR.CONTACT_US_PHONE)}
          className="sp-control sp-control--primary sp-control--empty"
          href="tel:+1 (833) 426-7933"
        >
          <span className="sp-control__body">
            <span className="sp-control__icon">
              <Icon id="sp--16--phone" />
            </span>
            <span className="sp-control__text">+1 (833) 426-7933</span>
          </span>
        </a>
      </SidebarSection>
      <Separator />
      <SidebarSection>
        <CreateTicket />
      </SidebarSection>
    </div>
  </Sidebar>
);

export default SidebarRight;
